<template>
  <div>
    <vx-card>
      <ListFechamentos :subjectPermission="subjectPermission"></ListFechamentos>
    </vx-card>
  </div>
</template>

<script>
import ListFechamentos from './ListFechamentos';

export default {
  data() {
    return {
      subjectPermission: 'Fechamento',
    };
  },
  methods: {},
  components: {
    ListFechamentos,
  },
};
</script>
